module.exports = __webpack_public_path__ + "img/1.b370ae15.jpg";